import { ThemeEvents } from '@theme/events';
import '@theme/fly-to-cart';

const MAX_AGE = 15000;
let pending;

const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const visible = (element) => {
  if (!element?.isConnected) return false;
  const rect = element.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight
    && rect.right > 0 && rect.left < window.innerWidth;
};

function remember(event) {
  const form = event.target.closest?.('product-form-component');
  if (!form || form.closest('.quick-add-modal')) return;
  pending = null;
  if (reducedMotion()) return;
  const productId = form.dataset.productId;
  const gifts = [...document.querySelectorAll('.item-gift-product[data-product-id]')]
    .filter((element) => element.dataset.productId === productId)
    .flatMap((card) => {
      const image = card.querySelector('.item-gift-product__image');
      return image?.complete && image.naturalWidth ? [{
        rewardId: card.dataset.rewardId,
        variantId: card.dataset.variantId,
        image: image.currentSrc || image.src,
      }] : [];
    });
  const button = event.submitter || form.querySelector('[ref="addToCartButton"]');
  const component = button?.closest('add-to-cart-component');
  if (!gifts.length || component?.dataset.addToCartAnimation !== 'true') return;
  const source = visible(button) ? button
    : document.querySelector('sticky-add-to-cart [ref="addToCartButton"]');
  if (!visible(source)) return;
  pending = {
    productId,
    gifts,
    source,
    sourceRect: source.getBoundingClientRect(),
    pathname: window.location.pathname,
    created: Date.now(),
    confirmed: false,
  };
}

function confirm(event) {
  const data = event.detail?.data;
  if (!pending || data?.source !== 'product-form-component' || String(data.productId) !== pending.productId) return;
  if (data.didError || !Number.isSafeInteger(data.itemDelta) || data.itemDelta < 1) {
    pending = null;
    return;
  }
  pending.confirmed = true;
}

function fly(event) {
  const gift = event.detail;
  if (!pending?.confirmed || !gift?.attemptId
    || !gift.triggerIds?.some((id) => String(id) === pending.productId)) return;
  const selected = pending.gifts.find((entry) => String(gift.variantId) === entry.variantId
    && String(gift.rewardId) === entry.rewardId);
  if (!selected) return;
  const intent = { ...pending, ...selected };
  pending.gifts = pending.gifts.filter((entry) => entry.variantId !== selected.variantId || entry.rewardId !== selected.rewardId);
  if (!pending.gifts.length) pending = null;
  if (reducedMotion() || document.visibilityState === 'hidden' || Date.now() - intent.created > MAX_AGE
    || window.location.pathname !== intent.pathname || !intent.source.isConnected) return;
  const sourceVisible = visible(intent.source);
  if (!sourceVisible && !document.querySelector('dialog[open]')) return;
  const destination = document.querySelector('.header-actions__cart-icon');
  if (!visible(destination)) return;
  const flight = document.createElement('fly-to-cart');
  if (typeof flight.showPopover !== 'function') return;
  flight.classList.add('fly-to-cart--main', 'item-gift-flight');
  flight.setAttribute('popover', 'manual');
  flight.setAttribute('aria-hidden', 'true');
  flight.style.setProperty('background-image', `url(${JSON.stringify(intent.image)})`);
  flight.style.setProperty('--start-opacity', '0');
  let anchor, removalObserver, cleanupTimer;
  const cleanup = () => {
    window.clearTimeout(cleanupTimer);
    removalObserver?.disconnect();
    flight.remove();
    anchor?.remove();
  };
  flight.destination = destination;
  try {
    if (!sourceVisible) {
      // Opening the cart can hide the sticky button; retain its submitted origin.
      const rect = intent.sourceRect;
      anchor = document.createElement('span');
      anchor.className = 'item-gift-flight-anchor';
      anchor.setAttribute('aria-hidden', 'true');
      Object.assign(anchor.style, {
        position: 'fixed', left: `${rect.left + rect.width / 2 - 0.5}px`, top: `${rect.top + rect.height / 2 - 0.5}px`,
        width: '1px', height: '1px', opacity: '0', pointerEvents: 'none',
      });
      document.body.append(anchor);
    }
    flight.source = anchor || intent.source;
    document.body.append(flight);
    if (anchor) {
      removalObserver = new MutationObserver(() => { if (!flight.isConnected) cleanup(); });
      removalObserver.observe(document.body, { childList: true });
    }
    flight.showPopover();
    cleanupTimer = window.setTimeout(cleanup, 1800);
  } catch (_) {
    cleanup();
  }
}

document.addEventListener('submit', remember, true);
document.addEventListener(ThemeEvents.cartUpdate, confirm);
document.addEventListener(ThemeEvents.cartError, () => { pending = null; });
document.addEventListener('mm:item-gift-added', fly);
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') pending = null; });
window.addEventListener('pagehide', () => { pending = null; });
